import { render, staticRenderFns } from "./DistributionsForm.vue?vue&type=template&id=8dc85ea6&"
import script from "./DistributionsForm.vue?vue&type=script&lang=js&"
export * from "./DistributionsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports